import { render } from "./login.vue?vue&type=template&id=01c5de53"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=01c5de53&lang=css"

import exportComponent from "D:\\phpstudy_pro\\好好玩官网\\wan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__